import { Box, Typography } from '@mui/material';
import addressFormatter from '@fragaria/address-formatter';

export const AddressField = ({ row }) => {
    const { country, state, city, street, house_number } = row;

    const address = addressFormatter.format(
        {
            street,
            houseNumber: house_number,
            city,
            countyCode: country,
            state,
        },
        { countryCode: country, output: 'array' },
    );

    return (
        <Box>
            <Typography variant="bodyMedium" noWrap>
                {address.join(', ')}
            </Typography>
            <Typography variant="bodyMedium" noWrap color="textSecondary">
                {country?.toCountryDisplayName()}
            </Typography>
        </Box>
    );
};
